import { g as getNumberFormat } from './formatNumber-c04a5a2d-5a59bc0a.js';

/**
 * @param {number} value The value to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 */
const formatPercentage = getNumberFormat({
  style: 'percent'
});
var formatPercentage$1 = formatPercentage;

export { formatPercentage$1 as f };
//# sourceMappingURL=formatPercentage-a3fa714f-866b2c18.js.map
